var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0L28.2983 28.2983","transform":"translate(1.2041 1.79102)","stroke":"#979797","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M28.2983 0.5L0.5 29.5","transform":"translate(1.2041 0.791016)","stroke":"#979797","strokeWidth":"2","key":1})]);
}

Close.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none"};

module.exports = Close;

Close.default = Close;
